export interface ValidationResult {
  isValid: boolean;
  errors: string[];
}

export function validatePhoneNumber(phoneNumber: string): ValidationResult {
  const errors: string[] = [];
  
  if (!phoneNumber.trim()) {
    errors.push("Phone number is required");
  } else if (phoneNumber.length < 6) {
    errors.push("Phone number must be at least 6 digits");
  } else if (!/^\d+$/.test(phoneNumber.replace(/[\s-()]/g, ''))) {
    errors.push("Phone number must contain only digits");
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}

// Simple boolean validation for quick checks
export function isValidPhoneNumber(phoneNumber: string): boolean {
  if (!phoneNumber || phoneNumber.length < 6) return false;
  return /^\d+$/.test(phoneNumber.replace(/[\s-()]/g, ''));
}

export function validatePassword(password: string): ValidationResult {
  const errors: string[] = [];
  
  if (!password) {
    errors.push("Password is required");
  } else {
    if (password.length < 8) {
      errors.push("Password must be at least 8 characters long");
    }
    if (!/[A-Z]/.test(password)) {
      errors.push("Password must contain at least one uppercase letter");
    }
    if (!/[0-9]/.test(password)) {
      errors.push("Password must contain at least one number");
    }
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
      errors.push("Password must contain at least one special character");
    }
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}

export function getPasswordStrength(password: string): { strength: number; label: string; color: string } {
  let strength = 0;
  
  if (password.length >= 8) strength++;
  if (/[A-Z]/.test(password)) strength++;
  if (/[a-z]/.test(password)) strength++;
  if (/[0-9]/.test(password)) strength++;
  if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) strength++;
  
  const labels = ["Very Weak", "Weak", "Fair", "Good", "Strong"];
  const colors = ["#ef4444", "#f97316", "#eab308", "#22c55e", "#16a34a"];
  
  return {
    strength,
    label: labels[Math.min(strength, 4)],
    color: colors[Math.min(strength, 4)]
  };
}